import { createModalsComponent } from 'modules/campaigns/lib/contexts/createModalContext';
import { NoOpComponent } from 'utils/reactHelpers';
import { useModalContext, ModalType, ModalProps } from '../contexts/ModalContext';
import { CreateGoalModal } from 'modules/goals/lib/components/CreateGoalModal';
import { DashboardFiltersModal } from './DashboardFiltersModal';

const HOMEPAGE_MODAL_COMPONENTS_MAPPER = {
  [ModalType.None]: NoOpComponent,
  [ModalType.CreateGoalModal]: CreateGoalModal,
  [ModalType.DashboardFiltersModal]: DashboardFiltersModal,
};

export const Modals = createModalsComponent<ModalType, ModalProps>(
  HOMEPAGE_MODAL_COMPONENTS_MAPPER as any,
  useModalContext,
);
